<template>
  <div class="rounded-t-none rounded-lg bg-gray-700 pb-2">
    <ul>
      <li
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[isActive === false ? 'bg-white text-gray-700' : 'bg-gray-700']"
        @click="
          setInactive()
          $emit('closeMenu')
        "
      >
        <img class="h-6 mr-3 cursor-pointer" src="../../assets/icons/redLight.svg" alt="Participation inactive" />
        Participation inactive
      </li>
      <li
        class="flex h-14 items-center w-full p-3 cursor-pointer select-none"
        :class="[isActive === true ? 'bg-white text-gray-700' : 'bg-gray-800']"
        @click="
          launchQuestion()
          $emit('closeMenu')
        "
      >
        <img class="h-6 mr-3" src="../../assets/icons/greenLight.svg" alt="Activer la participation" />
        <span v-if="isActive === false">Activer la participation</span>
        <span v-else>Participation activée</span>
        <div class="flex-grow text-right">
          <button
            class="h-8 w-8 rounded-full text-xs focus:outline-none"
            :class="[
              isActive === true && isActiveAuto === true ? 'border border-black bg-gray-100 text-black' : '',
              isActive === true && isActiveAuto === false ? 'border border-gray-500 bg-gray-100 text-gray-500' : '',
              isActive === false && isActiveAuto === true ? 'bg-white text-black' : '',
              isActive === false && isActiveAuto === false ? 'border border-gray-600 text-gray-600' : '',
            ]"
            @click.stop="
              $emit('toggleMenu', {
                name: 'activeAuto',
                withIcon: false,
                previousMenu: { name: 'live', withIcon: false },
              })
            "
          >
            Auto
          </button>
        </div>
      </li>
      <li
        class="flex h-14 items-center w-full p-3 bg-gray-700 select-none"
        @click="
          startTimer()
          $emit('closeMenu')
        "
      >
        <img class="h-6 mr-3" src="../../assets/icons/orangeLight.svg" alt="Timer" />
        Timer de {{ timer }} sec
        <div class="flex-grow text-right">
          <button
            class="h-8 w-8 rounded-full bg-gray-600 text-white focus:outline-none mr-3 cursor-pointer"
            @click.stop="
              $emit('toggleMenu', { name: 'timer', withIcon: false, previousMenu: { name: 'live', withIcon: false } })
            "
          >
            ...
          </button>
          <button
            class="h-8 w-8 rounded-full text-xs focus:outline-none cursor-pointer"
            :class="[isTimerAuto === true ? 'bg-white text-black' : 'border border-gray-600 text-gray-600']"
            @click.stop="toggleIsTimerAuto()"
          >
            Auto
          </button>
        </div>
      </li>
      <!--<li class="flex h-14 items-center w-full py-3 pl-2 pr-3 bg-gray-700 select-none">
        <img class="h-5 mr-2" src="../../assets/icons/results.svg" alt="Résultats en live" />
        Résultats en live
        <div class="flex-grow text-right">
          <button
            class="h-8 w-8 rounded-full bg-gray-600 text-white focus:outline-none mr-3 cursor-pointer"
            @click="
              $emit('toggleMenu', { name: 'timer', withIcon: false, previousMenu: { name: 'live', withIcon: false } })
            "
          >
            ...
          </button>
        </div>
        <div class="h-8 w-8">&nbsp;</div>
      </li>-->
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      isActive: (state) => state.live.isActive,
      isActiveAuto: (state) => state.live.isActiveAuto,
      timer: (state) => state.live.timer,
      isTimerAuto: (state) => state.live.isTimerAuto,
    }),
  },
  methods: {
    ...mapMutations("live", ["setInactive", "toggleIsTimerAuto", "startTimer"]),
    ...mapActions("live", ["launchQuestion"]),
  },
}
</script>

<style></style>
